import { useEffect } from 'react';

/**
 * Hides the Lovable badge on all environments.
 */
export const useHideLovableBadge = () => {
  useEffect(() => {
    // Inject CSS to hide the badge
    const style = document.createElement('style');
    style.id = 'hide-lovable-badge';
    style.textContent = '#lovable-badge { display: none !important; }';
    document.head.appendChild(style);
    
    return () => {
      const existingStyle = document.getElementById('hide-lovable-badge');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);
};
